import React, { FC } from 'react'

import styled from 'styled-components'

import { Icon, Txt } from 'src/components/atoms'

import { DateTxt } from '../texts'

const Container = styled.div`
  font-size: var(--s-1);
  border: var(--border-thin) var(--color-border-primary);
  border-radius: var(--r-4);
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  gap: var(--s0);
  box-shadow: var(--shadow-secondary-button-shadow);
  cursor: pointer;
`
const Box = styled.div`
  position: relative;
  background-color: var(--color-surface-secondary);
  width: var(--r5);
  flex-shrink: 0;
  height: 3.5em;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    width: 20px;
    height: 100%;
    background: rgb(255, 255, 255);
    border-right: 1px solid var(--color-border-primary);
    transform: skew(-12deg);
    left: -15px;
  }
`
const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 1em;
  transform: translateY(-50%);
`
const StyledIcon = styled(Icon)`
  width: 1.29em;
  aspect-ratio: 1 / 1;
  transition: transform 0.1s ease 0s;
`

const StyledDateTxt = styled(DateTxt)`
  font-weight: bold;
  font-size: 12px !important;
`
const EntirePeriodTxt = styled(Txt)`
  font-weight: bold;
  font-size: 12px !important;
`

type Props = {
  startDate?: Date
  endDate?: Date
  onClick: () => void
  forwardRef?: React.ForwardedRef<any>
  className?: string
}

const RangeDateDropdownBaseBase: FC<Props> = ({
  startDate,
  endDate,
  onClick,
  forwardRef,
  className,
  ...otherProps
}) => {
  return (
    <div className={className} ref={forwardRef} {...otherProps}>
      <Container onClick={onClick}>
        <div className="tw-w-full">
          <div className="tw-flex tw-items-center tw-gap-r-2 tw-ml-s-1">
            <Icon
              path="calendar/soft/line"
              size="--r0"
              className="tw-text-standardText-secondary"
            />
            {startDate || endDate ? (
              <div className="tw-flex tw-items-baseline tw-gap-r-4">
                {startDate && (
                  <>
                    <StyledDateTxt date={startDate} />
                    <Txt sizeType="s">から</Txt>
                  </>
                )}
                {endDate && (
                  <StyledDateTxt date={endDate} className="tw-text-correctGreen-default" />
                )}
              </div>
            ) : (
              <EntirePeriodTxt>全期間</EntirePeriodTxt>
            )}
          </div>
        </div>
        <Box>
          <IconWrapper>
            <StyledIcon path="chevron-down/soft/line" size="--r2" />
          </IconWrapper>
        </Box>
      </Container>
    </div>
  )
}

export const RangeDateDropdownBase = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  return <RangeDateDropdownBaseBase {...props} forwardRef={ref} />
})
